<template>
  <div>
    <CustomHead srcName="success.png">
      <h3>放款成功</h3>
      <p class="warn">系统将在30分钟内处理您的申请，</p>
      <p class="warn">请注意查收短信通知！</p>
    </CustomHead>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">借款人</span>
        <span class="infoListRight">{{
          this.otherPages.contractInfoObj.repay_acct_name
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">放款银行</span>
        <span class="infoListRight">{{
          this.otherPages.contractInfoObj.repay_bank_name
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">银行卡</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.repay_acct_no }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款金额</span>
        <span class="infoListRight">¥{{ loanAmt || '' }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款期限</span>
        <span class="infoListRight">{{
          this.otherPages.contractInfoObj.loan_exp
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款利率（单利）</span>
        <span class="infoListRight"
          >{{ this.otherPages.contractInfoObj.exec_rate }}%</span
        >
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款方式</span>
        <span class="infoListRight">{{
          this.otherPages.contractInfoObj.repay_type_name
        }}</span>
      </li>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="goToNextPage"
    />
  </div>
</template>
<script>
import CustomHead from '@/components/CustomHead.vue';
import Button from '@/components/Button.vue';
import { mapState } from 'vuex';

export default {
  name: 'signContract',
  data() {
    return {
      danger: 'danger',
      draw: '查看我的融资',
    };
  },
  components: {
    Button,
    CustomHead,
  },
  mounted() {},

  computed: {
    ...mapState({
      otherPages(val) {
        return val.otherPages;
      },
    }),
    loanAmt() {
      const amt = this.otherPages.contractInfoObj.loan_amt * 1;
      return amt && amt.toFixed(2);
    },
  },
  methods: {
    goToNextPage() {
      this.$router.push('/supermarket/v2/myload');
    },
  },
};
</script>
<style scoped>
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: #1C2438;
  font-size: 14px;
}
.warn {
  color: #9ea7b4;
  font-size: 17px;
  font-size: 700;
  text-align: center;
}
.infoListRight {
  color: #000;
  font-size: 14px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.headerStatus {
  padding-top: 35px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
</style>
